
Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.ImageUpload = (function () {

    function ImageUpload () {

        Monet.UI.Fields.Base.apply(this, arguments);

        this.fileFormats = [];
        this.maxFileSize = null;
        this.fileKey = Date.now();

        this.renderErrorMessages = (errorMessages) => {
            const monetMessage = new Monet.Form.Messages.InlineMessage();

            monetMessage.setScope(`#${this.entity} #form_and_grid`);
            monetMessage.setInfoType("error");
            monetMessage.setMessage({ errorMessages });
            monetMessage.triggerMessage();
        };

        this.validateSize = (file) => {
            return (file && this.maxFileSize && (this.maxFileSize * 1024 * 1024) >= file.size);
        };

        this.validateFileFormats = (file) => {
            return (file &&
                    this.fileFormats.length &&
                    file.name.match(new RegExp("^.*\.(" + this.fileFormats.join("|") + ")")));
        };

        this.validateFile = (file) => {
            let isValid = true;
            const errorMessages = [];

            //Validate file size and add error message
            if(file && !this.validateSize(file)) {
                isValid = false;
                errorMessages.push(Monet.Form.Messages.mountErrorMessageObject('uploadField.fileSizeError', this.maxFileSize));
            }

            //Validate file extension and add error message
            if(file && !this.validateFileFormats(file)) {
                isValid = false;
                errorMessages.push(Monet.Form.Messages.mountErrorMessageObject('uploadField.formatsError', this.fileFormats.join(', ').toUpperCase()));
            }

            if(!isValid) {
                //Render errors and remove image if it's invalid
                this.setImage('');
                this.renderErrorMessages(errorMessages);
                this.rootEl.classList.add('control-group', 'error');
            } else {
                //Hide errors if image is valid
                const alert = document.querySelector(`#${this.entity} .alert`);
                alert && (alert.style.display = 'none');
            }

            return isValid;
        };

        this.setValue = (value) => {
            this.value = value;
            if (this.value) {
                this.getFile();
            }
        }

        this.setImage = (image) => {
            this.image = image;
            if (this.previewImage) {
                this.previewImage.src = this.image;
                this.removeButton.style.display = this.image ? 'inline' : 'none'; //show remove button only if there's an image to remove
            }
            //make sure that empty values are consistent across the field's elements
            if (!image) {
                this.hiddenInput.value = '';
                this.setValue('');
            }
        };

        this.getFile = () => {
            this.imageContainer.classList.add('loading');
            const ajax = new Monet.Ajax();
            ajax.url = `${this.entity}/${this.name}`;
            ajax.method = 'get';
            ajax.success = (data) => {
                this.imageContainer.classList.remove('loading');
                if (data) {
                    this.setImage('data:image/png;base64,' + data);
                    this.oldValue = this.value;
                }
            };
            ajax.error = () => {
                this.imageContainer.classList.remove('loading');
                this.renderErrorMessages([Monet.Form.Messages.mountErrorMessageObject('uploadField.getImageError')]);
            };
            ajax.send();
        };

        this.convertImageToBinary = (fileBase64) => {
            if (!fileBase64) {
              return new Uint8Array(new ArrayBuffer(0));
            }
            const BASE64_MARKER = ';base64,';
            const base64Index = fileBase64.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
            const base64 = fileBase64.substring(base64Index);
            const raw = atob(base64);
            const rawLength = raw.length;
            const array = new Uint8Array(new ArrayBuffer(rawLength));
            for (let i = 0; i < rawLength; i++) {
                array[i] = raw.charCodeAt(i);
            }
            return array;
        };

        this.uploadFile = (file) => {
            //Create form data with file as a blob
            const formData = new FormData();
            formData.append('file', new Blob([this.convertImageToBinary(file)]));

            //Remove errors if any, show loading spinner and disable save buttons
            this.rootEl.classList.remove('control-group', 'error');
            this.imageContainer.classList.add('loading');
            const buttons = App.Forms[this.entity].form.buttons.btn_save;
            buttons.forEach(button => button.disable());

            const ajax = new Monet.Ajax({ contentType: 'multipart/form-data' });
            ajax.url = `${this.entity}/${this.name}/${this.fileKey}`;
            ajax.method = 'post';
            ajax.data = formData;
            ajax.success = (path) => {
                //Remove spinner, re-enable buttons and set image if response contains a file path
                this.imageContainer.classList.remove('loading');
                if (path) {
                    this.value = path;
                    this.setImage(file);
                    buttons.forEach(button => button.enable());
                }
            };
            ajax.error = () => {
                //Remove spinner, show error and re-enable buttons
                this.imageContainer.classList.remove('loading');
                this.renderErrorMessages([Monet.Form.Messages.mountErrorMessageObject('uploadField.uploadImageError')]);
                buttons.forEach(button => button.enable());
            };
            ajax.send();
        };

        //Remember to call this function in router's 'beforeSave'
        this.deleteFile = (saveCallback) => {
            //Send 'delete' request only if file was previously set and has changed
            if (this.oldValue && this.oldValue !== this.value) {
                const oldLogoKey = this.oldValue.split('/').pop();
                const ajax = new Monet.Ajax();
                ajax.url = `${this.entity}/${this.name}/${oldLogoKey}`;
                ajax.method = 'delete';
                ajax.success = () => {
                    this.oldValue = null;
                    if (saveCallback) {
                        saveCallback();
                    }
                };
                ajax.error = () => {
                    this.renderErrorMessages([Monet.Form.Messages.mountErrorMessageObject('uploadField.removeImageError')]);
                };
                ajax.send();
            } else if (saveCallback) {
                saveCallback();
            }
        };

        this.showImage = (event) => {
            const file = event.dataTransfer ? event.dataTransfer.files[0] : event.target.files[0];

            //If file is valid or empty, upload it or unset it
            if (this.validateFile(file)) {
                const reader = new FileReader();
                reader.onload = () => {
                    this.uploadFile(reader.result); //pass image as base64
                };
                if (file) {
                    reader.readAsDataURL(file);
                } else {
                    this.setImage('');
                }
            }
        };

        this.addEventListeners = () => {
            this.hiddenInput.addEventListener('change', this.showImage);

            this.chooseButton.addEventListener('click', () => {
                this.hiddenInput.click();
            });

            this.removeButton.addEventListener('click', () => {
                this.setImage('');
            });

            this.imageContainer.addEventListener("dragenter", () => {
                this.imageContainer.classList.add('onDrag');
            });

            this.imageContainer.addEventListener("dragleave", () => {
                this.imageContainer.classList.remove('onDrag');
            });

            this.imageContainer.addEventListener("dragover", (event) => {
                //Stop propagation and prevent default to allow drop
                event.stopPropagation();
                event.preventDefault();
            });

            this.imageContainer.addEventListener("drop", (event) => {
                event.preventDefault(); //prevent opening as link for some elements
                this.imageContainer.classList.remove('onDrag');
                this.showImage(event);
            });
        };

        this.createImageContainer = () => {

            //Create element that will contain an image preview after upload
            this.previewImage = document.createElement('img');
            this.previewImage.className = 'previewImage';
            this.previewImage.src = '';

            //Create element that allows drag and drop
            this.placeholderArea = document.createElement('div');
            this.placeholderArea.className = 'placeholderArea';
            this.placeholderText = document.createElement('div');
            this.placeholderText.className = 'placeholderText';
            this.placeholderText.innerText = Monet.I18n.getResourcesByKey('uploadField.placeholderText');
            this.placeholderArea.appendChild(this.placeholderText);

            //Add both elements to container
            this.imageContainer = document.createElement('div');
            this.imageContainer.className = 'imageContainer';
            this.imageContainer.appendChild(this.previewImage);
            this.imageContainer.appendChild(this.placeholderArea);

            this.rootEl.appendChild(this.imageContainer);
        };

        this.createButtonsContainer = () => {

            //Create hidden file input that will be triggered when choosing a new file
            this.hiddenInput = document.createElement('input');
            this.hiddenInput.type = 'file';
            this.hiddenInput.accept = '.' + this.fileFormats.join(',.');
            this.hiddenInput.style.display = 'none';
            this.rootEl.appendChild(this.hiddenInput);

            //Create 'Choose file' button
            this.chooseButton = document.createElement('span');
            this.chooseButton.className = 'chooseButton';
            this.chooseButton.innerText = Monet.I18n.getResourcesByKey('uploadField.chooseFile');

            //Create 'Remove' button
            this.removeButton = document.createElement('span');
            this.removeButton.className = 'removeButton';
            this.removeButton.innerText = Monet.I18n.getResourcesByKey('uploadField.removeFile');
            this.removeButton.style.display = this.image ? 'inline' : 'none';

            //Add both buttons to container
            this.buttonsContainer = document.createElement('div');
            this.buttonsContainer.className = 'buttonsContainer';
            this.buttonsContainer.appendChild(this.chooseButton);
            this.buttonsContainer.appendChild(this.removeButton);

            this.rootEl.appendChild(this.buttonsContainer);
        };

        this.render = function () {
            //Set meta data
            this.fileFormats = this.meta && this.meta.fileFormats || ['jpg', 'jpeg', 'png'];
            this.maxFileSize = (this.meta && this.meta.maxFileSize || 10);

            //Create field along with its elements and event listeners
            this.createBaseStructure();
            this.rootEl.classList.add('imageUploadField');
            this.createImageContainer();
            this.createButtonsContainer();
            this.addEventListeners();

            return this.rootEl;
        }

    }

    return ImageUpload;

}());
